import React from 'react';

const constants = {'tournament':'Amrut Cup'}

export default constants;


// WEBPACK FOOTER //
// ./src/config/constants.js